import React, {Fragment} from 'react';
import {
  getBackgroundColor,
  getCellValue,
  getCellColor,
  getEvaluationCellValue,
  getEvaluationComments,
  hasCellComments
} from "./analyticsUtils";

export default function ({reports, question, reportType, showInlineComments}) {
  return (
    <Fragment>
      {reports.map(report => (
        <td
          data-align="center"
          style={{
            backgroundColor: getBackgroundColor(reportType, report.responsesMap[question], report.settings.scale) || '#fff',
            color: getCellColor(reportType, report.responsesMap[question])
          }}
        >{
          report.responsesMap[question]? (
            <div
            >
              {report.responsesMap[question].isEvaluationRating
                ? getEvaluationCellValue(report.responsesMap[question], showInlineComments)
                : getCellValue(reportType, report.responsesMap[question])}
              {showInlineComments && hasCellComments(report.responsesMap[question]) && <span>-</span>}
            </div>
          ): (
            <div className="score">
              N/R
              {showInlineComments && hasCellComments(report.responsesMap[question]) && <span>-</span>}
            </div>
          )

        }
          {showInlineComments && report.responsesMap[question] && report.responsesMap[question].isEvaluationRating && getEvaluationComments(report.responsesMap[question]).map(comment => (
            <div key={comment.label}><b>{comment.label}:</b> <span dangerouslySetInnerHTML={{__html: comment.comment}} /></div>
          ))}
          {showInlineComments && report.responsesMap[question] && !report.responsesMap[question].isEvaluationRating && hasCellComments(report.responsesMap[question]) && (
            <div>{report.responsesMap[question].comment || report.responsesMap[question].observationComment}</div>
          )}
        </td>
      ))}
    </Fragment>
  )
}
